import React from 'react';
import { Header, Sidebar } from '@/components';

export const Layout = props => {
  return (
    <div className="fixed flex h-full w-full bg-strong">
      <div className="flex h-screen w-full flex-col">
        <Header />
        <main className="flex flex-1 overflow-hidden">{props.children}</main>
      </div>
    </div>
  );
};
